// Curated re-export of lucide-react icons under the `Icon.X` namespace shape
// the design bundle uses. Renames mirror the lu() adapter in design/ui-v2.jsx
// (Edit -> Pencil, Trash -> Trash2, Beaker -> FlaskConical, etc).
import {
  ArrowRight,
  ArrowLeft,
  ArrowUpRight,
  Check,
  X,
  Plus,
  Minus,
  Search,
  Filter,
  ChevronRight,
  ChevronDown,
  ChevronLeft,
  ChevronsRight,
  Download,
  Upload,
  FileText,
  File,
  Folder,
  Globe,
  Link,
  ExternalLink,
  Settings,
  Menu,
  MoreHorizontal,
  Pencil,
  Trash2,
  Copy,
  Eye,
  EyeOff,
  Play,
  Pause,
  RefreshCw,
  Loader,
  Info,
  TriangleAlert,
  CircleAlert,
  CircleCheck,
  CircleX,
  Clock,
  Calendar,
  User,
  Users,
  Lock,
  LogOut,
  LogIn,
  FlaskConical,
  Atom,
  BookOpen,
  Library,
  Sparkles,
  Languages,
  ScanText,
  ListChecks,
  ClipboardList,
  Database,
  Hash,
  Quote,
  Bookmark,
  Type,
  ScrollText,
  PenLine,
  Star,
  Tag as TagIcon,
  Send,
} from "lucide-react";

export const Icon = {
  ArrowRight,
  ArrowLeft,
  ArrowUpRight,
  Check,
  X,
  Plus,
  Minus,
  Search,
  Filter,
  ChevronRight,
  ChevronDown,
  ChevronLeft,
  ChevronsRight,
  Download,
  Upload,
  FileText,
  File,
  Folder,
  Globe,
  Link,
  ExternalLink,
  Settings,
  Menu,
  MoreHorizontal,
  Edit: Pencil,
  Trash: Trash2,
  Copy,
  Eye,
  EyeOff,
  Play,
  Pause,
  RefreshCw,
  Loader,
  Info,
  AlertTriangle: TriangleAlert,
  AlertCircle: CircleAlert,
  CheckCircle: CircleCheck,
  XCircle: CircleX,
  Clock,
  Calendar,
  User,
  Users,
  Lock,
  LogOut,
  LogIn,
  Beaker: FlaskConical,
  Atom,
  BookOpen,
  Library,
  Sparkles,
  Languages,
  ScanText,
  ListChecks,
  ClipboardList,
  Database,
  Hash,
  Quote,
  Bookmark,
  Type,
  ScrollText,
  PenLine,
  Star,
  Tag: TagIcon,
  Send,
} as const;

export type IconName = keyof typeof Icon;
export type IconComponent = (typeof Icon)[IconName];
